import React, { useEffect, useState } from 'react';
import { Popover, OverlayTrigger, Table } from "react-bootstrap";
import { toast } from 'react-toastify';

import CustomModal from "components/Modal/CustomModal";
import { AprobCambioCarrera, NoAprobCambioCarrera } from '../../funciones/EstudiantesFunction';

const CambioCarreraEst = (props) => {
    const [openOk, setOpenOk]       = useState(false);
    const [openNok, setOpenNok]     = useState(false);
    const [modalBtn1, setModalBtn1] = useState({icon: "fa fa-check", text: "Si"});
    const [modalBtn2, setModalBtn2] = useState({icon: "fa fa-check", text: "Si"});

    let noNull = (data) => {
        if (data === null || data === undefined) return "";
        return data;
    }

    let contenido = () => {
        if (props.data.Solvencia === false){
            return (
                <Popover bsSize="large" id="Ins">
                    <div style = {{fontSize: 12}} align = "center">Este estudiante <strong className = 'text-danger'> NO SE ENCUENTRA SOLVENTE</strong></div>
                </Popover>
            )
        }else{
            return (
                <Popover bsSize="large" id="Ins">
                    <div className="text-success" onClick = {() => setOpenOk(true)} style={{padding: 5, fontSize: 12, cursor: "pointer"}}><i className="fa fa-check"></i> Aprobar Cambio</div>
                    <div className="text-danger" onClick = {() => setOpenNok(true)} style={{padding: 5, fontSize: 12, cursor: "pointer"}}><i className="fa fa-times"></i> Rechazar Cambio</div>
                </Popover>
            )
        }
    }

    let modalAcepta = () => {
        if (openOk === false) return null;

        let aceptar = () => {
            AprobCambioCarrera(props.data.DataEst.id, (resp) => {
                toast.info("Se ha modificado correctamente la carrera del Estudiante",{autoClose: 4000});
                props.upd(resp)
            })
        }

        let contenido = () => (
            <div>¿Desea cambiar al estudiante <strong>{`${props.data.DataEst.nombre_1} ${noNull(props.data.DataEst.nombre_2)} ${props.data.DataEst.apellido_1} ${noNull(props.data.DataEst.apellido_2)}`}</strong> de <strong><span className = 'text-danger'>{props.data.CarreraAct.carrera_name}</span></strong> a <strong><span className = 'text-success'>{props.data.CarreraNew.carrera_name}</span></strong>?</div>
        )

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalBtn1.icon}></i> {modalBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openOk}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {aceptar}
                funcion2 = {() => setOpenOk(false)}
            />
        );
    }

    let modalRechazar = () => {
        if (openNok === false) return null;

        let rechazar = () => {
            NoAprobCambioCarrera(props.data.DataEst.id, (resp) => {
                toast.info("Se ha rechazado el cambio de carrera del estudiante",{autoClose: 4000});
                props.upd(resp)
            })
        }

        let contenido = () => (
            <div>¿Desea <strong>CANCELAR EL CAMBIO DE CARRERA</strong> del estudiante <strong>{`${props.data.DataEst.nombre_1} ${noNull(props.data.DataEst.nombre_2)} ${props.data.DataEst.apellido_1} ${noNull(props.data.DataEst.apellido_2)}`}</strong> de <strong><span className = 'text-danger'>{props.data.CarreraAct.carrera_name}</span></strong> a <strong><span className = 'text-success'>{props.data.CarreraNew.carrera_name}</span></strong>?</div>
        )

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalBtn2.icon}></i> {modalBtn2.text}</React.Fragment>}
                large = "medium"
                isopen =  {openNok}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {rechazar}
                funcion2 = {() => setOpenNok(false)}
            />
        );
    }

    return (
        <React.Fragment>
            <tr>
                <td style = {{fontSize: 12}}><strong>{props.data.DataEst.nacionalidad} {props.data.DataEst.ci}</strong></td>
                <td style = {{fontSize: 12}}>{props.data.DataEst.nombre_1} {noNull(props.data.DataEst.nombre_2)} {props.data.DataEst.apellido_1} {noNull(props.data.DataEst.apellido_2)}</td>
                <td style = {{fontSize: 12}} align = "center"><strong><span className = 'text-danger'>{props.data.CarreraAct.carrera_name}</span></strong></td>
                <td style = {{fontSize: 12}} align = "center"><strong><span className = 'text-success'>{props.data.CarreraNew.carrera_name}</span></strong></td>
                <td align = "center">
                    <OverlayTrigger  trigger="focus" placement="right" overlay={contenido()}>
                        <button style={{borderWidth: 1}} className="btn btn-primary"><i className="fa fa-cogs"></i> Acciones</button>
                    </OverlayTrigger>
                </td>
            </tr>
            {modalAcepta()}
            {modalRechazar()}
        </React.Fragment>
    )
}

export default CambioCarreraEst;


// WEBPACK FOOTER //
// ./src/views/Registros/CambioCarreraEst.jsx